import type { UnitValue } from "@repo/domain";

export function unitLabel(unit: UnitValue): string {
  return unit.code === "%" ? "%" : unit.display;
}

export function formatMeasured(value: number, unit?: UnitValue): string {
  if (!unit) return String(value);
  return `${value}${unit.code === "%" ? "" : " "}${unitLabel(unit)}`;
}
